"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxContext = void 0;
var react_1 = require("react");
var CheckboxContext = (0, react_1.createContext)({ groupName: '' });
exports.CheckboxContext = CheckboxContext;
//# sourceMappingURL=context.js.map